(function () {
  'use strict';

  const SCROLL_PERCENTAGE = 0.05;

  function init() {
    const container = document.getElementById('fixedBottomButtonsContainer');

    if (!container) {
      return;
    }

    const parentContainer = container.closest('.fixed-bottom-cta');

    if (!parentContainer) {
      return;
    }

    const currentLanguage = container.dataset.language || 'en';

    function calculateScrollThreshold() {
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
      return documentHeight * SCROLL_PERCENTAGE;
    }

    function handleScroll() {
      const scrollY = window.scrollY || window.pageYOffset;
      const threshold = calculateScrollThreshold();

      if (scrollY >= threshold) {
        parentContainer.classList.add('show');
      } else {
        parentContainer.classList.remove('show');
      }
    }

    if (currentLanguage) {
      container.classList.add('lang-' + currentLanguage);
    }

    window.addEventListener('scroll', handleScroll, { passive: true });

    handleScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
